import React from 'react';
import './WelcomeSection.css';

function WelcomeSection() {
  const keyHighlights = [
    'Safety during your tour with us',
    'The quality equipment',
    'Providing enough and nutritious food for both client and crew',
    'Paying our mountain and safari crew fair wages'
  ];

  return (
    <section className="welcome-section">
      <div className="welcome-container">
        <div className="welcome-content">
          <h2 className="welcome-title">
            <span className="swahili">Karibu</span> / Welcome to Digital Dream Safaris
          </h2>
          
          <p className="welcome-description">
            We are a Tanzanian local-owned Tour operator specializing in Kilimanjaro Climbs, 
            Wildlife Safaris, and Beach Vacations. Our office is located in the Kilimanjaro region, 
            Moshi town. We operate highly quality tours at a minimum cost without compromising 
            quality service on important things like:
          </p>
          
          <ul className="welcome-highlights">
            {keyHighlights.map((highlight, index) => (
              <li key={index}>
                <span className="highlight-icon">▶</span>
                {highlight}
              </li>
            ))}
          </ul>
          
          <div className="welcome-crew-info">
            <p>
              Our crew are First-Aid trained, certified, and well-trained professionals and receive 
              refresher courses every 2 years, accompanied by a Wilderness First-Responder in each trek. 
              These are the guys that help us take you on your tour and bring you back safely.
            </p>
            
            <p>
              Our commitment to superior customer service and expertise in tour services help us 
              make your vacation in Tanzania safe, comfortable, and a life-time experience. 
              Welcome and explore Tanzania with us!
            </p>
          </div>
        </div>
        
        <div className="welcome-image-container">
          <img 
            src="/assets/imgs/welcome/welcome.webp" 
            alt="Digital Dream Safaris team at Kilimanjaro Peak" 
            className="welcome-image"
          />
        </div>
      </div>
    </section>
  );
}

export default WelcomeSection;
